import { Button } from '@ds';
import { useFormContext } from 'react-hook-form';
import { ProfileFormType } from '../types';

interface ProfileActionProps {
  isReadOnly: boolean;
  handleFormState: () => void;
}
export const ProfileFormActions = ({ isReadOnly, handleFormState }: ProfileActionProps) => {
  const {
    formState: { isValid, isSubmitting },
    reset,
  } = useFormContext<ProfileFormType>();

  const onFormDiscard = () => {
    reset();
    handleFormState();
  };

  return (
    <div className="flex justify-between items-center">
      <h2 className="text-hl">My Profile</h2>
      {isReadOnly ? (
        <Button onPress={handleFormState} variant="solid" size="md" className="min-w-32.5">
          Edit Profile
        </Button>
      ) : (
        <div className="flex flex-row gap-2">
          <Button onPress={onFormDiscard} variant="outline" size="md" className="min-w-32.5">
            Discard
          </Button>
          <Button type="submit" variant="solid" size="md" isDisabled={!isValid || isSubmitting} className="min-w-32.5">
            Save Changes
          </Button>
        </div>
      )}
    </div>
  );
};
